import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import commonIS from '../public/locales/is/common.json';
import commonEN from '../public/locales/en/common.json';
import authIS from '../public/locales/is/auth.json';
import authEN from '../public/locales/en/auth.json';
import customersIS from '../public/locales/is/customers.json';
import customersEN from '../public/locales/en/customers.json';
import containersIS from '../public/locales/is/containers.json';
import containersEN from '../public/locales/en/containers.json';
import ordersIS from '../public/locales/is/orders.json';
import ordersEN from '../public/locales/en/orders.json';
import invoicesIS from '../public/locales/is/invoices.json';
import invoicesEN from '../public/locales/en/invoices.json';
import dashboardIS from '../public/locales/is/dashboard.json';
import dashboardEN from '../public/locales/en/dashboard.json';
import navigationIS from '../public/locales/is/navigation.json';
import navigationEN from '../public/locales/en/navigation.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      is: {
        common: commonIS,
        auth: authIS,
        customers: customersIS,
        containers: containersIS,
        orders: ordersIS,
        invoices: invoicesIS,
        dashboard: dashboardIS,
        navigation: navigationIS,
      },
      en: {
        common: commonEN,
        auth: authEN,
        customers: customersEN,
        containers: containersEN,
        orders: ordersEN,
        invoices: invoicesEN,
        dashboard: dashboardEN,
        navigation: navigationEN,
      },
    },
    fallbackLng: 'is', // Default to Icelandic
    supportedLngs: ['is', 'en'],
    defaultNS: 'common',
    ns: ['common', 'auth', 'customers', 'containers', 'orders', 'invoices', 'dashboard', 'navigation'],
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    react: {
      useSuspense: false, // Disable suspense for now
    },
  });

export default i18n;
